import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import InquiryCartDrawer from "@/components/InquiryCartDrawer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { AccountLayout, ProfilePage, WishlistPage, InquiriesPage } from "@/pages/Account";
import InquirySuccess from "@/pages/InquirySuccess";
import { About, Contact } from "@/pages/Static";
import {
  AdminLayout, AdminDashboard, AdminProducts, AdminInquiries,
  AdminCategories, AdminUsers
} from "@/pages/Admin";

function PublicShell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      {children}
      {!isAdmin && <Footer />}
      <InquiryCartDrawer />
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <PublicShell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Catalog />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/inquiry-success" element={<InquirySuccess />} />

                <Route path="/account" element={<AccountLayout />}>
                  <Route index element={<ProfilePage />} />
                  <Route path="wishlist" element={<WishlistPage />} />
                  <Route path="inquiries" element={<InquiriesPage />} />
                </Route>

                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="categories" element={<AdminCategories />} />
                  <Route path="inquiries" element={<AdminInquiries />} />
                  <Route path="users" element={<AdminUsers />} />
                </Route>
              </Routes>
            </PublicShell>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
